







import {Component, Prop, Vue} from "vue-property-decorator";
import {GuessDigit} from "@/classes/Guess.ts";

@Component
export default class DigitGuessState extends Vue {
    @Prop() public props!: GuessDigit;
    protected value: number = 0;
    protected isCorrectDigit = false;
    protected isCorrectPosition = false;

    public created() {
        this.value = this.props.value;
        this.isCorrectDigit = this.props.isCorrectDigit;
        this.isCorrectPosition = this.props.isCorrectPosition;
    }
}
